export default class Store {
    constructor(node) {
        this.node = node;
        this.mapNode = this.node.querySelector('#map-container');
        this.contattaStoreFormNode = this.node.querySelector('#form-contatta-store');
        
        this.storeSettings = window.storeSettings;

        this.initMap();
        this.addStoreMarker();
        
        this.addListeners();
    }

    addListeners() {
        let _this = this;

        $(this.contattaStoreFormNode).validate({
            getDataToSend: function (form)
            {
                return {
                    data: {
                        RecaptchaToken: form.querySelector("input[name='RecaptchaToken']").value,
                        CheckRequest: form.querySelector("input[name='CheckRequest']").value,
                        CheckField: form.querySelector("input[name='CheckField']").value,
                        CodiceStore: _this.storeSettings.id,
                        Nome: form.querySelector("input[name='nome']").value,
                        Cognome: form.querySelector("input[name='cognome']").value,
                        Email: form.querySelector("input[name='email']").value,
                        Stato: form.querySelector('input[name="stato"]').value,
                        CAP: form.querySelector('input[name="cap"]').value,
                        Nazione: form.querySelector("select[name='nazione']").options[form.querySelector("select[name='nazione']").selectedIndex].value,
                        Messaggio: form.querySelector("textarea[name='messaggio']").value,
                        Privacy: form.querySelector("input[name='privacy']").checked,
                        Newsletter: form.querySelector("input[name='newsletter']").checked,
                    }
                };
            },
            submitHandler: function () {
                var _this = this;

                grecaptcha.ready(function() {
                    grecaptcha.execute('6LeFHFAiAAAAAFH7mjVaACl4a8JniiSZYBONfEse', {action: 'validate_captcha'}).then(function(token) {
                        $('input[name="RecaptchaToken"]').val(token);

                        var submitHandler = $.validator.defaults.submitHandler.bind(_this);
                        submitHandler();
                    });
                });
            },
            callbackHandler: function (data, form)
            {
                form.querySelector('.response-text').innerHTML = data.d.HTML;
                if (data.d.Status)
                    form.querySelector('input[type="submit"]').style.display = 'none';
            }
        });
    }
    
    addStoreMarker() {
        let markerPosition = {lat: parseFloat(this.storeSettings.lat), lng: parseFloat(this.storeSettings.lng)};
        
        let marker = new google.maps.Marker({
            position: markerPosition,
            map: this.googleMap,
            icon: {
                url: this.storeSettings.markerImageUrl,
                scaledSize: new google.maps.Size(50, 50)
            }
        });
        
        this.googleMap.setCenter(markerPosition);
        
        let offsetX = -(this.mapNode.offsetWidth / 6);
        let offsetY = -(this.mapNode.offsetHeight / 6);
        
        this.googleMap.panBy(offsetX, offsetY);
    }
    
    initMap() {
        this.googleMap = new google.maps.Map(this.mapNode, {
            center: { lat: 52.515897, lng: 13.402780 },
            zoom: 13,
            disableDefaultUI: true,
            styles: [
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9c9c9c"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#f7f7f7"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#ededed"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                }
            ]
        });
    }

    static init() {
        let storeNode = document.querySelector("[data-store]");

        if (storeNode) {
            return new Store(storeNode);
        }
    }
}